import { Link } from "react-router-dom";
import { ShieldCheck, Truck, RotateCcw, Lock, Instagram, Twitter, Youtube } from "lucide-react";
import { Logo, HeptagonPattern } from "@/components/Logo";
import { NewsletterForm } from "@/components/NewsletterSection";

const TRUST = [
  { icon: Lock, label: "Secure Checkout", sub: "256-bit SSL encryption" },
  { icon: Truck, label: "Worldwide Shipping", sub: "Free over $150" },
  { icon: RotateCcw, label: "30-Day Returns", sub: "No questions asked" },
  { icon: ShieldCheck, label: "Authenticity", sub: "Numbered editions" },
];

export const Footer = () => (
  <footer className="relative bg-[#050505] border-t border-white/10 overflow-hidden">
    <HeptagonPattern opacity={0.04} />
    {/* Trust badges */}
    <div className="relative border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-5 lg:px-10 py-10 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {TRUST.map((t) => (
          <div key={t.label} className="flex items-start gap-3" data-testid={`trust-badge-${t.label.toLowerCase().replace(/\s/g, "-")}`}>
            <t.icon size={22} strokeWidth={1.5} className="text-[#0FB5A3] mt-0.5" />
            <div>
              <p className="text-sm text-white font-display">{t.label}</p>
              <p className="text-xs text-white/40 mt-0.5">{t.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="relative max-w-[1600px] mx-auto px-5 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Logo size="md" />
        <p className="text-sm text-white/40 mt-5 leading-relaxed max-w-xs">
          Luxury streetwear rooted in Haitian heritage. Built on progress, exclusivity, and generational wealth.
        </p>
        <div className="flex gap-4 mt-6">
          {[Instagram, Twitter, Youtube].map((Icon, i) => (
            <a key={i} href="#social" aria-label="Social link" className="p-2 border border-white/10 text-white/60 hover:text-[#0FB5A3] hover:border-[#0FB5A3]/40 transition-colors">
              <Icon size={16} strokeWidth={1.5} />
            </a>
          ))}
        </div>
      </div>

      <div className="lg:col-span-2">
        <p className="label-757 mb-5">Shop</p>
        <ul className="space-y-3">
          {[
            ["All Products", "/shop"],
            ["Men", "/shop?gender=men"],
            ["Women", "/shop?gender=women"],
            ["Collections", "/collections"],
            ["Wishlist", "/wishlist"],
          ].map(([label, to]) => (
            <li key={label}>
              <Link to={to} className="text-sm text-white/50 hover:text-white transition-colors">{label}</Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-2">
        <p className="label-757 mb-5">Brand</p>
        <ul className="space-y-3">
          {[
            ["About", "/about"],
            ["Lookbook", "/lookbook"],
            ["Journal", "/journal"],
            ["Contact", "/contact"],
            ["FAQ", "/faq"],
          ].map(([label, to]) => (
            <li key={label}>
              <Link to={to} className="text-sm text-white/50 hover:text-white transition-colors">{label}</Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-2">
        <p className="label-757 mb-5">Support</p>
        <ul className="space-y-3">
          {[
            ["Shipping Policy", "/shipping-policy"],
            ["Returns", "/returns"],
            ["Privacy Policy", "/privacy"],
            ["Terms & Conditions", "/terms"],
          ].map(([label, to]) => (
            <li key={label}>
              <Link to={to} className="text-sm text-white/50 hover:text-white transition-colors">{label}</Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-2 md:col-span-2">
        <p className="label-757 mb-5">The Movement</p>
        <p className="text-sm text-white/40 mb-4">Join for 10% off your first order.</p>
        <NewsletterForm source="footer" compact />
      </div>
    </div>

    <div className="relative border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-5 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/30 tracking-wider">© {new Date().getFullYear()} 7FIFTY7™. WE NOW US NEXT</p>
        <div className="flex items-center gap-2 text-white/30">
          <Lock size={12} />
          <span className="text-[10px] tracking-[0.2em] uppercase">Secured by Stripe · Visa · Mastercard · Amex · Apple Pay · Google Pay</span>
        </div>
      </div>
    </div>
  </footer>
);
